import { checkIntegrationStatus } from '@/api/apiDeck'
import { APIDECK_CLEANUP, apiDeckIntegrationRoutine, externalApiDeckIntegrationCompleteRoutine, routeNameAfterIntegrationRoutine } from '@/store/modules/apiDeck/routines'
import { logoutRoutine } from '@/store/modules/auth/routines'
import requestFlow from '@/utils/requestFlow'
import { state as initialState } from './index'

export default {
  ...requestFlow(apiDeckIntegrationRoutine, checkIntegrationStatus).actions,

  [routeNameAfterIntegrationRoutine.TRIGGER](context, payload) {
    context.commit(routeNameAfterIntegrationRoutine.TRIGGER, payload)
  },

  [externalApiDeckIntegrationCompleteRoutine.TRIGGER](context, payload) {
    context.commit(externalApiDeckIntegrationCompleteRoutine.TRIGGER, payload)
  },

  [logoutRoutine.SUCCESS](context) {
    context.commit(APIDECK_CLEANUP, initialState)
  }
}
